import AboutMe from './AboutMe';
import ChangeAvatar from './ChangeAvatar/ChangeAvatar';
import DescribeText from './DescribeText';
import EditProfileInfo from './EditProfileInfo';
import ErrorText from './ErrorText';
import PhoneNumberModal from './PhoneNumberModal';

export { PhoneNumberModal, ChangeAvatar, DescribeText, EditProfileInfo, ErrorText, AboutMe };
